<template>
  <div :style="isFetchingDetail ? { opacity: 0.3, pointerEvents: 'none' } : {}">
    <button v-if="isHistory" @click="$emit('handle-back')" class="btn btn-outline-secondary btn-sm" type="button">
      {{ $t("message.back") }}
    </button>
    <div class="mt-3 mb-4">{{ $t("message.find_person.results") }}</div>
    <div v-if="SW0000ButNoResults">
      {{ data.searchInputName }}({{ translated_searchInputName }}) {{ $t("message.find_person.results_exists_by_response_code") }}
    </div>
    <div v-if="data.resultsScore" class="text-secondary">{{ $t("message.find_person.results_score") }}: {{ policeInfoToType(data.resultsScore) }}</div>
    <div v-for="typeList in resultsList">
      <div class="mb-5" v-if="typeList.list && typeList.list.length">
        <h4>{{ typeList.title }}</h4>
        <div class="list-group">
          <div v-for="item in typeList.list"
            class="list-group-item list-group-item-action flex-column align-items-start">
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1">{{ item.title }}</h5>
              <small style="white-space: nowrap;">{{ timeAgo(item.sortTime) }}</small>
            </div>
            <div class="d-flex justify-content-between">
              <div>
                <p class="mb-1 h6">{{ item.body }}</p>
                <small>{{ timeDate(item.sortTime) }}</small>
              </div>
              <button class="btn btn-primary btn-sm p-0 mt-auto mb-0 h-auto" @click="() => handleDetail(item)">
                <span class="m-0 px-3 py-2">{{ $t("message.find_person.order_detail") }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-model="modalShow" hide-footer lazy size="xl">
      <div class="w-100 d-flex justify-content-end">
        <div style="width: 106px;">
          <js-pdf :pageMarginsInPx="[30, 30, 30, 30]" :pageFullWidthInPx="1400" :filename="'detail.pdf'">
            <template v-slot="pdfProps">
              <DetailView :pdfProps="pdfProps" :response="response" :responseType="responseType"
                :isLoading="isFetchingDetail" />
            </template>
          </js-pdf>
        </div>
      </div>
      <DetailView :response="response" :responseType="responseType" :isLoading="isFetchingDetail" />
    </b-modal>
  </div>
</template>
<script>
import moment from "moment";
import DetailView from "./detail-view.vue";
export default {
  inject: ["runBiller", "updateBiller", "policeInfoToType"],
  components: { DetailView },
  props: {
    data: {
      type: Object,
      required: true,
    },
    isHistory: {
      type: Boolean,
      default: false,
      required: false,
    },
    handleToggleHistory: {
      type: Function,
      required: false,
    },
  },
  data() {
    return {
      modalShow: false,
      isFetchingDetail: false,

      // To save for current object when re-click on detail button
      currentSessionResponses: {
        // <entryId>: <response>
      },

      response: {}, // <response>
      responseType: "", // <type>
      
      translated_searchInputName: "",
    };
  },
  mounted() {
    this.translate(this.data.searchInputName).then((res) => {
      this.translated_searchInputName = res;
    });
  },
  methods: {
    async handleDetail(item) {
      this.isFetchingDetail = true;
      this.responseType = item.dataType;

      this.response = {};
      if (this.currentSessionResponses[item.entryId]) {
        this.response = this.currentSessionResponses[item.entryId];
        this.isFetchingDetail = false;
        this.modalShow = true;
        return;
      }

      if (this.isHistory) {
        const res = await axios.get(window.base + `/PersonalLegalInfo/GetSearchHistory?searchType=2&dataId=${item.entryId}`);
        // if history exists
        if (Array.isArray(res.data) && res.data.length > 0) {
          const _data = JSON.parse(res.data[0].response).resp_data[item.dataType][0];
          this.currentSessionResponses[item.entryId] = _data;
          this.response = _data;

          this.isFetchingDetail = false;
          this.modalShow = true;
          return;
        }
      }

      const reduceBalanceId = await this.runBiller("200", item.entryId);
      if (reduceBalanceId) {
        this.modalShow = true;
      } else {
        this.isFetchingDetail = false;
        return;
      }


      const formData = new FormData();
      formData.append("dataId", item.entryId);
      formData.append("locale", this.$i18n.locale);
      const res = await axios.post(window.base + "/PersonalLegalInfo/GetPersonalLegalInfoDetails", formData);
      const _data = res.data.resp_data[item.dataType][0];
      this.currentSessionResponses[item.entryId] = _data;
      this.response = _data;
      this.updateBiller("200", true);
      this.isFetchingDetail = false;
    },
    timeAgo(timestamp) {
      return moment(Number(timestamp)).locale(this.$i18n.locale).fromNow();
    },
    timeDate(timestamp) {
      return moment(Number(timestamp)).locale(this.$i18n.locale).format("LL");
    },
    async translate(text) {
      const response = await axios.get(
        window.base +
        "/library/TranslateNext?text=" +
        text +
        "&source=zh&target=" +
        this.$i18n.locale,
      );
      return response.data.translation
    },
  },
  computed: {
    SW0000ButNoResults() {
      return this.data.resp_code === "SW0000" && !(this.resultsList?.flatMap(x => x.list) || []).length;
    },
    resultsList() {
      return [
        {
          title:
            this.$t("message.find_person.types.listOf") +
            " " +
            this.$t("message.find_person.types.all"),
          list: this.data.allList,
        },
        {
          title:
            this.$t("message.find_person.types.listOf") +
            " " +
            this.$t("message.find_person.types.cpws"),
          list: this.data.cpwsList,
        },
        {
          title:
            this.$t("message.find_person.types.listOf") +
            " " +
            this.$t("message.find_person.types.ktgg"),
          list: this.data.ktggList,
        },
        {
          title:
            this.$t("message.find_person.types.listOf") +
            " " +
            this.$t("message.find_person.types.zxgg"),
          list: this.data.zxggList,
        },
        {
          title:
            this.$t("message.find_person.types.listOf") +
            " " +
            this.$t("message.find_person.types.shixin"),
          list: this.data.shixinList,
        },
        {
          title:
            this.$t("message.find_person.types.listOf") +
            " " +
            this.$t("message.find_person.types.fygg"),
          list: this.data.fyggList,
        },
        {
          title:
            this.$t("message.find_person.types.listOf") +
            " " +
            this.$t("message.find_person.types.ajlc"),
          list: this.data.ajlcList,
        },
        {
          title:
            this.$t("message.find_person.types.listOf") +
            " " +
            this.$t("message.find_person.types.bgt"),
          list: this.data.bgtList,
        },
        {
          title:
            this.$t("message.find_person.types.listOf") +
            " " +
            this.$t("message.find_person.types.sifacdk"),
          list: this.data.sifacdkList,
        },
        {
          title:
            this.$t("message.find_person.types.listOf") +
            " " +
            this.$t("message.find_person.types.pmgg"),
          list: this.data.pmggList,
        },
      ];
    },
  },
};
</script>
<style></style>